import { render, staticRenderFns } from "./MachineDrawers.vue?vue&type=template&id=632bc579&"
import script from "./MachineDrawers.js?vue&type=script&lang=js&"
export * from "./MachineDrawers.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports